










































import Vue from "vue";
import Issue, { IssueType } from "@/models/util/issue";
import Show from "@/models/Show";
import { GlobalStore } from "@/store";
import { Mutations } from "@/store/mutations";

export default Vue.extend({
  name: "Issues",
  components: {},
  data: function () {
    return {
      filter: "all",
    };
  },
  computed: {
    issues(): Issue[] {
      const issues: Issue[] = [];
      const show: Show = this.$store.state.show;
      issues.push(...show.issues);
      show.stuntSheets.forEach((sheet) => {
        issues.push(...sheet.issues);
        sheet.stuntSheetDots.forEach((dot) => {
          issues.push(...dot.issues);
        });
      });
      if (this.filter === "current") {
        return issues.filter((issue: Issue) => {
          const currentSS: number = this.$store.getters.getSelectedStuntIndex;
          return issue.stuntSheets.some((ss: number) => {
            return ss === currentSS;
          });
        });
      }
      return issues;
    },
  },
  methods: {
    getLocation(issue: Issue): string {
      if (issue.stuntSheets !== undefined && issue.stuntSheets.length >= 1) {
        if (issue.dots.length !== 0) {
          return `SS ${issue.stuntSheets[0] + 1} Dots ${issue.dots.join(", ")}`;
        }
        return `SS ${issue.stuntSheets[0] + 1}`;
      }
      return "";
    },
    color(type: IssueType): string {
      switch (type) {
        case IssueType.ERROR: {
          return "red";
        }
        default: {
          return "grey";
        }
      }
    },
    goTo(issue: Issue) {
      if (issue.stuntSheets !== undefined && issue.stuntSheets.length >= 1) {
        GlobalStore.commit(Mutations.SET_SELECTED_SS, issue.stuntSheets[0]);
        if (issue.dots.length !== 0) {
          GlobalStore.commit(Mutations.CLEAR_SELECTED_DOTS);
          GlobalStore.commit(Mutations.ADD_SELECTED_DOTS, issue.dots);
        }
      }
    },
  },
});
